import { emailRegex } from '@pharmaplan/common';
import * as Yup from 'yup';

import strings from '../../../../localization';

const validation = () =>
  Yup.object().shape({
    email: Yup.string()
      .trim()
      .matches(emailRegex, strings.emailValid)
      .required(strings.requiredField),
  });

export default validation;
